// extracted by mini-css-extract-plugin
export default {"modal":"TerminalModal_modal__g8AwW","active":"TerminalModal_active__dO42j","modalContainer":"TerminalModal_modalContainer__ALEq5","spinnerIcon":"TerminalModal_spinnerIcon__Nfq0F"};